import axios from "axios"
import moment from "moment/moment"

// export const baseURL = "http://localhost:5001/"
export const baseURL = "https://api-admin.closedigit.com/"

const Axios = axios.create({
    baseURL: baseURL,
})


export const api = async (url, type, data, headers, options = {}) => {

    let requestTypes = ['get', 'post', 'put', 'delete']
    let requestType = requestTypes.find((reqType) => { return reqType === type })

    if (requestType) {
        try {
            const response = await Axios({ method: requestType, url: url, data: data, headers: headers, ...options })
            return response
        } catch (e) {
            return Promise.reject(e)
        }
    } else {
        return Promise.reject("invalid request type")
    }
}

export const isValidToken = (expiryTime) => {
    const expiryMoment = moment.unix(expiryTime)
    const nowMoment = moment(new Date())
    const result = nowMoment.isBefore(expiryMoment)
    return result
}